import { CompanyFragment } from '@willow/graphql-iso/src/portal';

import { PaymentsPaused } from '../payments-paused/PaymentsPaused';

export const MaturedLoanWithPausedPayments = ({ company }: { company: CompanyFragment }) => {
  return (
    <PaymentsPaused
      company={company}
      title="Your loan has matured"
      subtitle="Refer to your payoff statement for amount due"
      contactFormTitle="Your loan is now due in full. You may be eligible for an extension, please contact us for more details."
    />
  );
};
